import React, {Component} from "react";  
import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import $ from "jquery";
import {css} from "@emotion/core";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import ModalD from "react-awesome-modal";
import {connect}  from  "react-redux";
import axios from "axios";
import {Link} from "react-router-dom";
import Switch from "react-switch";
import {BeatLoader} from 'react-spinners';
import Picker from 'react-month-picker'
import MonthBox from "views/MonthBox.jsx";
import "../../assets/css/monthpicker/month-picker.css";
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align: center;
`;
function formatNumber(num) {
    //return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
    var n1, n2;
    num = num + '' || '';
    // works for integer and floating as well
    n1 = num.split('.');
    n2 = n1[1] || null;
    n1 = n1[0].replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
    num = n2 ? n1 + '.' + n2 : n1;
    return num;
}
var todayDate = new Date();
var timestamp  = new Date().getTime();
var yesterday = new Date(Date.now() - 24*60*60*1000);
var tod = moment(todayDate).format('MM/DD/YYYY');
var yest = moment(todayDate).format('MM/DD/YYYY');
var todShow = moment(todayDate).format('D MMM YYYY');
var yestShow = moment(todayDate).format('D MMM YYYY');
var todSend = moment(todayDate).format('YYYY-MM-DD');
var yestSend = moment(todayDate).format('YYYY-MM-DD');
var date_limit = moment(todayDate).format('MM/DD/YYYY');
Array.prototype.move = function(from,to){
    this.splice(to,0,this.splice(from,1)[0]);
    return this;
};
var year = new Date().getFullYear();
var mo = new Date().getMonth();
var month_val = '';
if(mo.toString().length==1){
    month_val = "" +0+mo;
}
else {
    month_val = mo;
}

function getMonth(date) {
    var month = date.getMonth() + 1;
    return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
}
let dateDefault = new Date();
let monthd = dateDefault.setMonth(dateDefault.getMonth() -1);
dateDefault = dateDefault.toDateString();
dateDefault = new Date(dateDefault);
let monthDefaults = getMonth(dateDefault);
let yearDefault= dateDefault.getFullYear();

var month_years = "" +monthDefaults+yearDefault;
function enabledBody() {
    $('body').removeClass("back-disabled");
}

function disabledBody() {
    $('body').addClass("back-disabled");
}

class InnovitiBusinessSnapshot extends Component{
    constructor(props) {
        super(props);
        this.state ={
            dateTo:tod,
            dateLimit:date_limit,
            dateToShow:todShow,
            todSend:todSend,
            yestSend:yestSend,
            datefrom:yest,
            datefromShow:yestShow,
            loading:true,
            model_visible : false,
            file_url: '',
            rfile: '',
            merchant_list_box: false,
            chain_list_box: false,
            store_list_box: false,
            acq_bank_list_box: false,
            tableHeaders:[],
            tableBody:[],
            num_of_column:[],
            mvalue: {year: yearDefault, month: monthDefaults},
            m_yr: month_years,
            check_empty:false
        }
        this.handleClickMonthBox = this.handleClickMonthBox.bind(this);
        this.handleAMonthChange = this.handleAMonthChange.bind(this);
        this.handleAMonthDissmis = this.handleAMonthDissmis.bind(this);
    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        }
    componentDidMount() {
        this.subMenuPermission();
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({
            user_id:decoded._id
        });

        //console.log(decoded.object_type);
        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: decoded.object_code,
        });

        if(decoded.object_type=='Admin' || decoded.object_type=='Innoviti') {

            this.get_innoviti_bussiness_report(month_years);

            this.setState({
                merchant_list_box: true,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
            })
        }

     
        else {
            this.unauthorize_access();
        }

    }
    subMenuPermission(){
        const token = localStorage.usertoken;
        let subMenuPermissions = [];
        let reportPermissions = [];
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        AllAccessPermissions.map((permissionName, i) => {
            if(permissionName.access_type=='Submenu'){
                subMenuPermissions.push(permissionName.access_name);
            }
            if(permissionName.access_type=='report'){
                reportPermissions.push(permissionName.access_name);
            }
        });
        if(reportPermissions.includes("innoviti_business_snapshot_report")===false){
            this.unauthorize_access();
        }
    }
    unauthorize_access(){
        localStorage.removeItem("usertoken");
        localStorage.removeItem("userPermission");
        this.setState({
            loggedIn: false
        });
        alert("Unauthorized Access");
        window.location.href = "/";
    }


    handleEvent(event, picker, e) {
        this.setState({
            todSend: moment(picker.endDate).format('YYYY-MM-DD'),
            yestSend: moment(picker.startDate).format('YYYY-MM-DD'),
            datefromShow: moment(picker.startDate).format('D MMM YYYY'),
            dateToShow: moment(picker.endDate).format('D MMM YYYY')
        });
        if(event.type=='apply'){
            this.get_BBIR_report(this.state.uTypeIDs, this.state.yestSend, this.state.todSend)
        }
    }
    handleClickMonthBox (e) {
        this.refs.pickAMonth.show()
    }
    handleAMonthChange(value, text) {
        var month = '';
        if(text.toString().length==1){
            month = "" +0+text;
        }
        else {
            month = text;
        }

        var month_year = "" +month+value;
        this.setState({
            m_yr: month_year,
            mvalue: {year: value, month: text}
        });
        this.get_innoviti_bussiness_report(month_year)
        //this.refs.pickAMonth.hide()
        this.handleAMonthDissmis(this.state.mvalue);
    }
    handleAMonthDissmis(value) {
        // this.setState({
        //     mvalue: value
        // });
    }
    get_innoviti_bussiness_report(month_year) {
        if ($.fn.DataTable.isDataTable('#IBSRTable')) {
            $('#IBSRTable').DataTable().destroy();
        }
        this.setState({
            loading:true
        })
        axios.post(config.get('API_URL') + '/reports/innoviti_business_snapshot', {
                for_month: month_year,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
                // console.log(response.data.data)

                this.setState({
                    loading:false
                })

            let tableHeaders = [];
                if(response.data.data.length>0){
                    var no_of_rows = response.data.data.length;
                    const keys = Object.keys(response.data.data[0]);
                    keys.forEach(function (k) {
                        //console.log(k)
                        tableHeaders.push(k);
                    });
                    var num_of_column = tableHeaders.length;
                    //alert(num_of_column);
                    this.setState({
                        tableHeaders:tableHeaders,
                        tableBody:response.data.data,
                        check_empty:false
                    })
                    setTimeout(function(){
                        let total = '';
                        let pageTotal = '';
                        $('#IBSRTable').DataTable( {
                            searching: false,
                            bInfo : false,
                            paging: false,
                            "bSort": false,
                            "responsive": false,
                            // "scrollX": true,

                        } );

                    }, 200);
                } else {
                    this.setState({
                        check_empty:true
                    })
                }

        });
    }

    ibs_report_download (e){
       this.setState({
            is_download: false,
            model_visible: true,
            file_url: '',
            rfile: ''
        });
        var postData = {
            for_month: this.state.m_yr,
            download: true
        };

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/reports/innoviti_business_snapshot_download",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "octet/stream"
                });
                let fileName = timestamp+'_innoviti_business_snapshot_report.csv.gz';
                let rfile = fileName.replace(/\"/g, "");
                //console.log(fileName)
                //let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                // a.href = url;
                // a.download = rfile;
                // a.click();
                // window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true,
                    file_url: url,
                    rfile: rfile
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    downloadFile(e){ //alert(this.state.file_url);
        let a = document.createElement('a');
        a.href = this.state.file_url;
        a.download = this.state.rfile;
        a.click();
        window.URL.revokeObjectURL(this.state.file_url);
    }
    closeModal() {
        this.setState({
            model_visible : false
        });
    }
    render() {
        const pickerLang = {
            months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            from: 'From', to: 'To',
        };
        const mvalue = this.state.mvalue
        ;
        const makeText = m => {
            if (m && m.year && m.month) return (pickerLang.months[m.month-1] + '. ' + m.year);
            return '?'
        };

        const headersList =this.state.tableHeaders.map((header, i) => {
            return (
                <th width="20%" key={i}>{header}</th>
            )
        });

        const tableData = this.state.tableBody.map((data, index) => {

             return (
                <tr key={index} >
                    {this.state.tableHeaders.map((value1, index1) => {
                         return <td width="70" key={index1}  >{data[value1]}</td>
                    })}
                </tr>
            )
        });


        return(
          
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">Innoviti Business Snapshot</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content" style={{minHeight:450}}>

                                    <div className="">
                                        <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                            <div><label> Select Month: </label></div>
                                            <Picker
                                                ref="pickAMonth"
                                                theme="light"
                                                years={{
                                                    max: {
                                                        year: new Date().getFullYear(),
                                                        month: new Date().getMonth()
                                                    },
                                                    min: {year: 2019, month: 4}
                                                }}
                                                // years={new Date().getFullYear()}
                                                value={mvalue}
                                                lang={pickerLang.months}
                                                onChange={this.handleAMonthChange}
                                                onDismiss={this.handleAMonthDissmis}
                                            >
                                                <MonthBox value={makeText(mvalue)} onClick={this.handleClickMonthBox} />
                                            </Picker>
                                        </div>
                                        {/*<div className="col-md-2 filter-bottom5 date-icon-small">*/}



                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    {this.state.loading===false && this.state.check_empty===false?
                                    <div className="">
                                        <a href="#" className="export-iv-Button" role="button" onClick={this.ibs_report_download.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>:null}
                                    <div className="clearfix"></div>
                                    {this.state.loading===false && this.state.check_empty===false?
                                        <div>
                                            <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                                <table id="IBSRTable" className="table table-striped table-hover">
                                                    <thead>
                                                        <tr>
                                                            {headersList}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {tableData}
                                                    </tbody>

                                                </table>


                                            </div>
                                        </div>
                                        :null}
                                    {this.state.loading===false && this.state.check_empty===true?
                                        <p className="categoryEmi" style={{textAlign:"center"}}>No matching records found</p> :null }
                                    <BeatLoader
                                        css={override}
                                        sizeUnit={"px"}
                                        size={20}
                                        color={'#123abc'}
                                        loading={this.state.loading}
                                    />
                                    <ModalD visible={this.state.model_visible} width="300" height="100" effect="fadeInUp">
                                        <div className="download-popup-model">
                                            <div className="message-content">
                                                {this.state.file_url==''?
                                                    <div>
                                                        <p>Generating CSV...</p>
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Cancel
                                                        </a>
                                                    </div>
                                                    :
                                                    <div className="dwnloadLink">
                                                        <a href="#" onClick={this.downloadFile.bind(this)}>
                                                            <i className="fa fa-download" aria-hidden="true"></i>Download
                                                        </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Close
                                                        </a>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </ModalD>
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
         
        );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)(InnovitiBusinessSnapshot)